import { render } from "./PassThrough.vue?vue&type=template&id=f42cfbc2&scoped=true"
import script from "./PassThrough.vue?vue&type=script&lang=js"
export * from "./PassThrough.vue?vue&type=script&lang=js"

import "./PassThrough.vue?vue&type=style&index=0&id=f42cfbc2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f42cfbc2"]])

export default __exports__